<template>
	<main class="school-mgn-list" style="background: #f5f5fb;">
		<div class="mainList">
			<el-form label-width="80px" :inline="true" @submit.native.prevent style="margin-left: 13px;padding: 5px 0">
				<el-form-item>
          <InputTopTip v-model="selectedOptions" :placeholder="querylist">
            <el-cascader
              :key="refreshItem"
              ref="cascaderArr"
              placeholder=""
              v-model="selectedOptions"
              size="small"
              :options="options"
              :props="{
                value: 'id',
                label: 'name',
                children: 'child',
                expandTrigger: 'click',
                emitPath: false
              }"
              @change="handleChange($event)"
            >
            </el-cascader>
          </InputTopTip>
				</el-form-item>
				<el-form-item>
          <InputTopTip v-model="filter_form.name" placeholder="学校名字">
            <el-input
              style="width: 220px;"
              placeholder=""
              @keyup.native.enter=";(currentPage = 1), refreshDataList()"
              v-model="filter_form.name"
              size="small"
            >
            </el-input>
          </InputTopTip>
				</el-form-item>

				<el-form-item>
          <InputTopTip v-model="filter_form.SchoolAdminName" placeholder="校管名字">
            <el-input
              style="width: 150px;"
              placeholder=""
              @keyup.native.enter=";(currentPage = 1), refreshDataList()"
              v-model="filter_form.SchoolAdminName"
              size="small"
            >
            </el-input>
          </InputTopTip>
				</el-form-item>
				<el-form-item>
          <InputTopTip v-model="filter_form.phone" placeholder="手机号码">
            <el-input
              style="width: 200px;"
              placeholder=""
              v-model="filter_form.phone"
              @keyup.native.enter=";(currentPage = 1), refreshDataList()"
              size="small"
              maxlength="11"
            >
            </el-input>
          </InputTopTip>
				</el-form-item>
			</el-form>

			<div style="display: flex; margin-left: auto;">
				<template>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="margin-right: 15px; width: 70px;"
						@click=";(currentPage = 1), refreshDataList()"
						>搜索</el-button
					>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="
							background: #f7f8fa;
							border: 1px solid #dcdcdc;
							color: #4b4b4b !important;
							margin-right: 12px;
							width: 70px;
						"
						@click="clearList"
						>重置</el-button
					>
				</template>
			</div>
		</div>
		<div>
			<section class="list-area">
				<div
					class="list-area-otis"
					v-if="
						$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						$permissions([SP31001, SP31002, SP31003, SP31004, SP31005])
					"
				>
					<template>
						<div style="display: flex; padding-left: 18px;">
							<el-button
								type="primary"
								size="small"
								icon="el-icon-plus"
								style="margin-right: 15px;"
								@click="Newbuttont"
								v-permission="SP31001"
								>新建</el-button
							>
							<el-button
								size="small"
								icon="el-icon-download"
								style="background: #f7f8fa; border: 2px solid #f7f8fa; color: #4b4b4b !important;"
								@click="$refs.importDialog.dialogVisible = true"
								v-permission="SP31002"
								>批量创建</el-button
							>
							<el-button
								size="small"
								icon="el-icon-upload2"
								style="background: #f7f8fa; border: 2px solid #f7f8fa; color: #4b4b4b !important;"
								@click="exportExcel('school-admins', '校管数据')"
								v-permission="SP31003"
								v-if="multipleSelection.length > 0"
								>导出</el-button
							>
						</div>
						<div>
							<el-button
								type="primary"
								size="small"
								icon="el-icon-delete"
								:class="multipleSelection.length === 0 ? 'box' : 'box2'"
								:disabled="multipleSelection.length === 0"
								@click="batchDelete()"
								v-if="multipleSelection.length > 0"
								v-permission="SP31004"
								>批量删除</el-button
							>
							<el-button
								type="primary"
								size="small"
								icon="el-icon-refresh-right"
								:class="multipleSelection.length === 0 ? 'box' : 'box2'"
								:disabled="multipleSelection.length === 0"
								@click="batchResetPwd()"
								v-if="multipleSelection.length > 0"
								v-permission="SP31005"
								>重置密码</el-button
							>
						</div>
					</template>
				</div>
				<el-table
					:data="dataList"
					row-class-name="row"
					tooltip-effect="dark"
					@selection-change="handleSelectionChange"
					:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				>
					<el-table-column
						type="selection"
						width="60"
						align="center"
						v-if="$permissions([SP31003, SP31004, SP31005])"
					></el-table-column>
					<el-table-column align="left" label="学校名称" prop="school.name" />
					<el-table-column align="left" label="辖区" prop="school.district_division">
						<template slot-scope="scope">
							{{ scope.row?.school?.district_division?.l1_name }}/{{ scope.row?.school?.district_division?.l2_name }}{{
								scope.row?.school?.district_division?.l3_name ? '/' + scope.row?.school?.district_division?.l3_name : ''
							}}</template
						>
					</el-table-column>
					<el-table-column align="left" label="校管名字" prop="account.realname" />

					<el-table-column align="left" label="账号" prop="account.login_name" />
					<el-table-column align="left" label="手机号码" prop="account.mobile" />
					<el-table-column align="center" label="微信授权">
						<template slot-scope="scope">
							<svg class="icon" aria-hidden="true" style="width: 23px; height: 23px; outline: none; box-shadow: none;">
								<use v-if="scope.row.account.openid === null" xlink:href="#icon-wechartstate"></use>
								<use v-else xlink:href="#icon-wechartstate2"></use>
							</svg>
						</template>
					</el-table-column>

					<template
						v-if="
							$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
							$permissions([SP31006, SP31007, SP31008])
						"
					>
						<el-table-column align="center" label="操作" class-name="opscol" width="140">
							<template v-slot:default="slot">
								<div class="table-mgn2">
									<div style="color: #3f6af7;" @click="Editbutton(slot.row.id)" v-permission="SP31006">
										<el-tooltip content="编辑" placement="bottom" effect="light">
											<svg class="icon" aria-hidden="true">
												<use xlink:href="#icon-iconoutlinesetting"></use>
											</svg>
										</el-tooltip>
									</div>

									<div
										class="icon delete"
										style="color: #f13048;"
										@click="promptRemove(slot.row.id)"
										v-permission="SP31007"
									>
										<el-tooltip content="删除" placement="bottom" effect="light">
											<svg
												class="icon"
												aria-hidden="true"
												style="width: 100%; height: 100%; outline: none; box-shadow: none;"
											>
												<use xlink:href="#icon-deltred"></use>
											</svg>
										</el-tooltip>
									</div>

									<div style="color: #666666;" @click="resetPwd(slot.row.uid)" v-permission="SP31008">
										<el-tooltip content="重置" placement="bottom" effect="light">
											<i aria-hidden="true" class="icon el-icon-refresh-right"></i>
										</el-tooltip>
									</div>
								</div>
							</template>
						</el-table-column>
					</template>
				</el-table>
				<div class="pagination-page">
					<span class="pagetotal">总计：{{ totalItems }}条/{{ Math.ceil(totalItems / pageSize) }}页</span>
					<el-pagination
						class="pagination"
						background
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-size="pageSize"
						:total="totalItems"
						:current-page.sync="currentPage"
						:page-sizes="[10, 20, 50, 100]"
						layout="prev,pager,next,jumper,sizes"
						style="margin-top: 21px; margin-left: 10px;"
					>
					</el-pagination>
				</div>
			</section>
		</div>

		<el-dialog
			class="practice-sheet-new-edit-dialog"
			width="400px"
			:close-on-click-modal="false"
			:visible.sync="practiceSheetNewEditDialog"
			@close="practiceSheetNewEditDialogClose"
			:destroy-on-close="true"
		>
			<div class="dialog-title2" slot="title">
				<span>{{ dialogTitleType }}</span>
				<el-divider></el-divider>
			</div>
			<template>
				<el-form :model="model" ref="newForm" :rules="vaRules" @submit.native.prevent="confirm">
					<el-form-item prop="name">
            <InputTopTip v-model="model.name" placeholder="真实姓名">
              <el-input placeholder="" v-model="model.name" style="width: 100%;" size="medium" />
            </InputTopTip>
					</el-form-item>

					<el-form-item prop="schoolname" style="margin-top: 25px;">
            <InputTopTip v-model="model.schoolname" placeholder="学校名称">
              <el-autocomplete
                placeholder=""
                v-model="model.schoolname"
                style="width: 100%;"
                size="medium"
                :fetch-suggestions="querySearchAsync"
                :trigger-on-focus="false"
                @select="handleSelect"
                ref="myAutocomplete"
              >
                <template slot-scope="{ item }">
                  {{ item.value }}---------<span class="addr">{{ item.address }}</span>
                </template>
              </el-autocomplete>
            </InputTopTip>
					</el-form-item>

					<el-form-item style="margin-top: 25px;">
						<div :class="arereid === 2 ? 'arere' : ''">
              <InputTopTip v-model="newselectedOptions" :placeholder="'辖区'">
                <el-cascader
                  :disabled="true"
                  ref="areaRef"
                  v-model="newselectedOptions"
                  style="width: 100%;"
                  size="medium"
                  placeholder=""
                  :options="options"
                  :props="{
                    value: 'id',
                    label: 'name',
                    children: 'child',
                    emitPath: false
                  }"
                />
              </InputTopTip>
						</div>
					</el-form-item>

					<!-- <el-form-item prop="phone" style="margin-top: 25px;">
						<el-input
							placeholder="请输入手机号码"
							v-model="model.phone"
							style="width: 100%;"
							size="medium"
							maxlength="11"
						/>
					</el-form-item> -->
					<div style="margin-top: 25px;">
						<el-divider></el-divider>
					</div>
					<el-form-item
						style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;"
					>
						<el-button
							class="btn-close"
							@click="practiceSheetNewEditDialogClose"
							style="width: 80px; height: 32px; line-height: 1px;"
							>取 消</el-button
						>
						<el-button
							class="btn-prim"
							type="primary"
							native-type="submit"
							style="width: 80px; height: 32px; line-height: 1px;"
							>{{ onTitleType }}</el-button
						>
					</el-form-item>
				</el-form>
			</template>
		</el-dialog>
		<!-- 批量导入 -->
		<batch-import-account ref="importDialog" :target="'school_admin'" />
	</main>
</template>
<script>
import { SP31001, SP31002, SP31003, SP31004, SP31005, SP31006, SP31007, SP31008 } from '@/utils/permissionMap.js'
import BatchImportAccount from '@/components/BatchImportAccount'
import { throttle } from 'lodash'
import { exportXLS } from '@/utils/job.js'
const ErrorImg = require('@/assets/test_client/Group 682.png')
const ErrorImg2 = require('@/assets/test_client/Group 681.png')
const wechatrstate = require('@/assets/test_client/Frame.png')
const wechatrstate2 = require('@/assets/test_client/Frame2.png')
const cityOptions = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10']
export default {
	props: [],
	data() {
		return {
			SP31001,
			SP31002,
			SP31003,
			SP31004,
			SP31005,
			SP31006,
			SP31007,
			SP31008,
			querylist: '省 / 市 / 区',
			ErrorImg,
			ErrorImg2,
			wechatrstate,
			wechatrstate2,
			areaOptions: {},
			selectedOptions: [], //列表省市区
			listId: null,
			refreshItem: 0,
			options: [],
			options2: [],
			options3: [],
			arereid: 1, //编辑辖区颜色id
			//新建省市区
			newareaOptions: {},
			newselectedOptions: [],
			checkList: [],
			checkList1: [],
			newlistId: null,
			model: {
				name: '',
				Perfect: '省 / 市 / 区', //回显省市区
				schoolname: '',
				phone: ''
			},
			EditId: null,
			SchoolId: null,
			loginname: '',
			vaRules: {
				name: [
					{
						required: true,
						message: '请输入真实姓名',
						trigger: 'change'
					}
				],
				phone: [
					{
						validator: (rule, value, callback) => {
							if (value) {
								let reg = /^1[3-9][0-9]{9}$/
								if (!reg.test(value)) {
									callback(new Error('请输入正确的手机号'))
								} else {
									callback()
								}
							} else {
								callback(new Error('请输入手机号'))
							}
						},
						trigger: 'change'
					}
				],
				schoolname: [
					{
						required: true,
						message: '未选择学校，请输入学校后在下拉框选择对应学校',
						trigger: 'change'
					}
				],
				checkList: [
					{
						validator: (rule, value, callback) => {
							if (this.checkList.length === 0) {
								callback(new Error('学段至少勾选一个'))
							} else {
								callback()
							}
						},
						trigger: 'change'
					}
				]
			},
			dialogTitleType: '', //新建||编辑
			onTitleType: '', //确定||更新
			activeTab: 'personal',
			filter_form: {
				bureauFilter: null,
				SchoolAdminName: '',
				phone: '',
				name: ''
			},
			bureauList: [
				{ val: 1, name: '音乐' },
				{ val: 2, name: '美术' }
			],
			dataList: [],
			pageSize: 10,
			totalItems: 0,
			currentPage: 1, // 第几页
			multipleSelection: [], // 批量删除
			currentPracticeSheetObj: null,
			dialogVisible: false,
			practiceSheetNewEditDialog: false, //设置新建班级弹窗
			checkAll: false, //全选
			isIndeterminate: false, //全选
			cities: cityOptions,
			Classke: null
		}
	},
	components: {
		BatchImportAccount
	},
	created() {
		/* this.getNewAreaOptions()
		this.getAreaOptions() */
		this.RegionalLevel()

		if (this.$route.query?.schoolAdminlist?.district_division != undefined) {
			this.listId = this.$route.query.schoolAdminlist.district_division.code
			// this.querylist =
			// 	this.$route.query.schoolAdminlist.district_division.l1_name +
			// 	'/' +
			// 	this.$route.query.schoolAdminlist.district_division.l2_name +
			// 	'/' +
			// 	this.$route.query.schoolAdminlist.district_division.l3_name
			this.filter_form.name = this.$route.query.schoolAdminlist.name
      this.selectedOptions = Number(this.listId) ? Number(this.listId) : []
      this.refreshDataList()
      return
		}
    try {
      const { school_name, name, mobile, region_code, page, page_size } = this.$store.state.searchParams[this.$route.name]
      this.currentPage = page
      this.pageSize = page_size
      this.listId = region_code
      this.selectedOptions = Number(this.listId) ? Number(this.listId) : []
      this.filter_form.name = school_name
      this.filter_form.SchoolAdminName = name
      this.filter_form.phone = mobile
      this.refreshDataList()
    } catch(err) {
      console.log('正常~')
      this.refreshDataList()
    }
	},
	methods: {
		async RegionalLevel() {
			this.$api.school
				.ssxlist(0)
				.then(res => {
					this.options = this.removeEmptyItems(res)
					this.options3 = res
				})
				.catch(err => {
					console.log('获取列表报错')
				})
		},
    removeEmptyItems(arr) {
			const newArr = []
			for (let i = 0; i < arr.length; i++) {
				const item = arr[i]
				if (item.child?.length >= 1) {
					item.child = this.removeEmptyItems(item.child)
				} else {
					item.child = undefined
				}
				newArr.push(item)
			}
			return newArr
		},
		async querySearchAsync(queryString, cb) {
			let param = {
				name: queryString
			}
			let res = null
			res = await this.$api.school.list({
				fu_name: param.name,
				page_size: 99
				// region_code: this.newlistId
			})
			let result = res.data.map(item => {
				return {
					value: item.name,
					id: item.id,
					address: item.district_division.l1_name + item.district_division.l2_name + (item.district_division.l3_name || ''),
					addressInputValue:
						item.district_division.l1_name +
						' / ' +
						item.district_division.l2_name +
						(item.district_division.l3_name ? ' / ' + item.district_division.l3_name : ''),
					addressId: item.district_division.l3_id ? [item.district_division.l1_id, item.district_division.l2_id, item.district_division.l3_id] : [item.district_division.l1_id, item.district_division.l2_id],
					middle_school: item.middle_school,
					high_school: item.high_school,
					primary_school: item.primary_school
				}
			})
			if (this.timer) {
				clearTimeout(this.timer)
			}
			this.timer = setTimeout(() => {
				cb(result)
			}, 300)
		},
		handleSelect(item) {
			this.model.Perfect = item.addressInputValue
			this.model.id = item.id
			this.SchoolId = item.id
			this.$refs['myAutocomplete'].activated = false
			// 省市区回显~傻逼逻辑~傻逼
			this.newselectedOptions = item.addressId
			this.$refs['areaRef'].inputValue = this.model.Perfect
			this.newlistId = item.addressId[2]
		},
		//全选
		handleCheckAllChange(val) {
			this.checkList = val ? cityOptions : []
			this.isIndeterminate = false
		},
		//单选
		handleCheckedCitiesChange(value) {
			let checkedCount = value.length
			this.checkAll = checkedCount === this.cities.length
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length
		},
		getAreaData(data = { deep: 0, value: 0, code: null }) {
			return new Promise(resolve => {
				this.$api.school.ssxlist(data.value).then(res => {
					resolve(res && res && res) // 将获取到的数据传出
				})
			})
		},
		getAreaOptions() {
			let _this = this
			this.areaOptions = {
				lazy: true,
				lazyLoad(node, resolve) {
					const { level } = node
					// 调用后端接口获取数据
					_this.getAreaData(node.data).then(data => {
						const nodes = data.map(item => ({
							leaf: level >= 2,
							label: item.name,
							value: item.id,
							code: item.code,
							level
						}))
						resolve(nodes)
					})
				}
			}
		},
		classkeChange(val) {
			this.Classke = val
		},
		getnewAreaData(data = { deep: 0, value: 0 }) {
			return new Promise(resolve => {
				this.$api.school.ssxlist(data.value).then(res => {
					resolve(res && res && res) // 将获取到的数据传出
				})
			})
		},
		getNewAreaOptions() {
			let _this = this
			this.newareaOptions = {
				lazy: true,
				lazyLoad(node, resolve) {
					const { level } = node
					// 调用后端接口获取数据
					_this.getnewAreaData(node.data).then(data => {
						const nodes = data.map(item => ({
							leaf: level >= 2,
							label: item.name,
							value: item.id,
							code: item.code,
							level
						}))
						resolve(nodes)
					})
				}
			}
		},
		//新建班级按钮
		Newbuttont() {
			this.arereid = 1
			this.practiceSheetNewEditDialog = true
			this.dialogTitleType = '新建校管'
			this.onTitleType = '确定'
			this.options2 = this.options3
		},
		//编辑班级按钮
		async Editbutton(id) {
			this.arereid = 2
			this.dialogTitleType = '编辑校管'
			this.onTitleType = '更新'
			this.practiceSheetNewEditDialog = true
			this.EditId = id
			this.options2 = this.options3
			let res = null
			res = await this.$api.school_admin.show(id)
			if (this.dialogTitleType === '编辑校管') {
				this.SchoolId = res.school.id
				this.model.name = res.account.realname
				this.model.schoolname = res.school.name
				this.model.phone = res.account.mobile
				for (let i in res.school.district_division) {
          console.log(i)
					var arr = [] //声明一个新的数组
					arr.push({
						province: res.school.district_division.l1_name, //把省份保存到新的数组里
						city: res.school.district_division.l2_name, //把市保存到新的数组里
						county: res.school.district_division.l3_name //把区保存到新的数组里
					})
				}
				//进一步处理成可以回显的数据
				arr.map(item => {
					this.model.Perfect = item.province + ' / ' + item.city + ' / ' + item.county
				})
        this.newselectedOptions = Number(res.school.district_division.code) // 修复辖区展示为空
			}
		},
		expandleChange(list) {
			for (var i = 0; i < list?.length; i++) {
				if (list[i].child?.length < 1) {
					list[i].child = undefined
				} else {
					this.expandleChange(list[i]?.child)
				}
			}
			return list
		},

		handleChange(row) {
			const checkedNode = this.$refs['cascaderArr'].getCheckedNodes()
			this.listId = checkedNode[0].data.code
			this.refreshDataList()
		},
		handleChange2(row) {
			const checkedNode = this.$refs['areaRef'].getCheckedNodes()
			this.newlistId = checkedNode[0].data.code
		},
		practiceSheetNewEditDialogClose() {
			this.currentPracticeSheetObj = null
			this.practiceSheetNewEditDialog = false
			this.EditId = null
			this.SchoolId = null
			this.$refs['newForm'].resetFields()
			this.newselectedOptions = []
			this.options2 = null
			this.checkList = []
			this.newlistId = null
			this.model.name = ''
			this.model.Perfect = '省 / 市 / 区'
			this.dialogTitleType = ''
		},
		//新建班级
		confirm: throttle(function () {
			this.$refs['newForm'].validate(async valid => {
				if (valid) {
					if (this.onTitleType == '确定') {
						if (this.model.id != null) {
							this.$api.school_admin
								.create({
									school_id: this.model.id,
									account: {
										realname: this.model.name,
										mobile: this.model.phone
									}
								})
								.then(cRes => {
									this.$message.success('新建成功，请刷新数据')
									this.practiceSheetNewEditDialogClose()
									// this.refreshDataList1()
                  this.refreshDataList()
								})
						} else {
							this.model.schoolname = ''
						}
					} else if (this.onTitleType == '更新') {
						this.$api.school_admin
							.update(this.EditId, {
								school_id: this.SchoolId,
								account: {
									realname: this.model.name,
									mobile: this.model.phone
								}
							})
							.then(cRes => {
								this.$message.success('更新成功，请刷新数据')
								this.practiceSheetNewEditDialogClose()
								// this.refreshDataList1()
                this.refreshDataList()
							})
					}
				} else {
					console.log('error')
				}
			})
		}, 3000),
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		//每页下拉只显示的数据
		handleSizeChange(val) {
			this.currentPage = 1
			this.pageSize = val
			this.refreshDataList()
		},
		//当前点击的是第几页
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage
			this.refreshDataList()
		},
		async refreshDataList() {
			let res = null
      const params = {
				page: this.currentPage,
				page_size: this.pageSize,
				region_code: this.listId,
				school_name: this.filter_form.name,
				name: this.filter_form.SchoolAdminName,
				mobile: this.filter_form.phone
			}
      this.$store.commit('setSearchParams', { key: this.$route.name, params})
			res = await this.$api.school_admin.list(params)
			this.totalItems = res.meta.total
			this.pageSize = parseInt(res.meta.per_page)
			this.dataList = res.data
		},
		async refreshDataList1() {
			let res = null
			res = await this.$api.school_admin.list({
				page: this.currentPage,
				page_size: this.pageSize,
				region_code: null,
				school_name: null,
				name: null,
				mobile: null
			})
			this.totalItems = res.meta.total
			this.pageSize = parseInt(res.meta.per_page)
			this.dataList = res.data
		},

		clearList() {
			this.filter_form.name = ''
			this.filter_form.SchoolAdminName = ''
			this.filter_form.phone = ''
			this.filter_form.bureauFilter = null
			this.listId = null
			this.Classke = null
			this.selectedOptions = []
			this.querylist = '省 / 市 / 区'
			this.refreshItem++
			this.refreshDataList()
		},
		async exportExcel(key, fileName) {
			// let text = this.multipleSelection.length > 0 ? '已选择' : '全部'
			// this.$confirm(`此操作将导出${text}的教师数据，是否继续?`, '温馨提示', {
			// 	confirmButtonText: '确定',
			// 	cancelButtonText: '取消',
			// 	type: 'warning'
			// })
      const tiemstamp = new Date()
      let job = {
        job_id: tiemstamp.getTime(),
        created_at: tiemstamp,
        progress: 0,
        name: fileName,
        type: 'XLS',
      }
      let ids = this.multipleSelection.map(item => {
        return item.uid
      })
			this.$confirm(`是否要导出登录密码?`, '温馨提示', {
				distinguishCancelAndClose: true,
				confirmButtonText: '是',
				cancelButtonText: '否',
				type: 'warning'
			})
				.then(async () => {
					exportXLS(this, { ...job, msgType: key, prop: { has_password: true, ids } })
				})
				.catch(async action => {
					if (action === 'close') {
						return
					}
          exportXLS(this, { ...job, msgType: key, prop: { has_password: true, ids } })
				})
        .finally(() => {
          this.$store.state.job.isDot = true
        })
		},
		downloadFile(blob, fileName) {
			const url = window.URL.createObjectURL(new Blob([blob]))
			let a = document.createElement('a')
			a.href = url
			// 保证下载文件后缀一致
			a.download = `${fileName}.xlsx`
			a.click()
			window.URL.revokeObjectURL(url)
		},

		//批量删除数据
		batchDelete() {
			this.$confirm('此操作将永久删除该校管数据, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(res => {
					let idse = this.multipleSelection.map(item => item.uid)
					this.$api.school_admin
						.SchoolAdminDeletes({
							ids: idse
						})
						.then(cRes => {
							if (cRes.success === true) {
								this.$message.success('删除成功，请刷新数据')
								this.refreshDataList()
							}
						})
				})
				.catch(() => {})
		},
		batchResetPwd() {
			this.$confirm('此操作将重置密码, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(res => {
					let idse = this.multipleSelection.map(item => item.uid)
					this.$api.teacher
						.ResetPwd({
							ids: idse
						})
						.then(cRes => {
							if (cRes.success === true) {
								this.refreshDataList()
								this.$message({
									message: '重置密码成功，密码为：000000',
									type: 'success'
								})
							}
						})
				})
				.catch(() => {})
		},
		promptRemove(id) {
			this.$confirm('此操作将永久删除该校管数据, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.$api.school_admin.delete(id)
				this.$message.success('删除成功，请刷新数据')
				// 刷新
				this.refreshDataList()
			})
		},
		resetPwd(id) {
			this.$confirm('此操作将重置密码, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(res => {
					this.$api.teacher
						.ResetPwd({
							ids: [id]
						})
						.then(cRes => {
							if (cRes.success === true) {
								this.refreshDataList()
								this.$message({
									message: '重置密码成功，密码为：000000',
									type: 'success'
								})
							}
						})
				})
				.catch(() => {})
		}
	}
}
</script>
<style lang="scss" scoped>
// .arere {
// 	/deep/ .el-cascader .el-input .el-input__inner::placeholder {
// 		color: #323232;
// 	}
// }
.action-btn:focus {
	background-color: #ff5e2a;
	border-color: #ff5e2a;
	opacity: 1 !important;
}
.box {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.box:hover {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.box2 {
	margin-right: 15px;
	background: #f7f8fa;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}

.pagetotal {
	width: 200px;
	margin-left: 20px;
	font-size: 14px;
	line-height: 70px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.addr {
	font-size: 14px;
	color: #b4b4b4;
}
.dotClass {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	display: block;
}
.schoolNianji {
	width: 32px;
	height: 28px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	line-height: 28px;
	-webkit-background-clip: text;
}
.schollAxie {
	height: 35px;
	display: flex;
	-webkit-box-pack: justify;
	justify-content: space-between;
	vertical-align: middle;
	-webkit-box-align: center;
	align-items: center;
}
.schollApex {
	width: 32px;
	height: 28px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	line-height: 28px;
	-webkit-background-clip: text;
	display: flex;
}
.el-form-item {
	margin-bottom: 1px;
}
.pagination {
	width: 100%;
	margin-top: 20px;
	text-align: right;
}
.pagination .el-pagination__total {
	float: left;
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	-webkit-background-clip: text;
}
.pagination .el-pagination__jump {
	margin-left: 9px;
	font-weight: normal;
	color: #666666;
}
.ClassesRadio {
	margin-right: 32px;
	padding-bottom: 15px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	-webkit-background-clip: text;
}
.ClassChekbox {
	margin-right: 8px;
	width: 90px;
	height: 32px;
	padding-bottom: 0px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	-webkit-background-clip: text;
}
</style>
